import React from 'react';

interface ExpiredProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Expired: React.FC<ExpiredProps> = (props) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 27.5C9.10744 27.5 6.16117 27.5 4.33058 25.6694C2.5 23.8388 2.5 20.8926 2.5 15C2.5 9.10744 2.5 6.16117 4.33058 4.33058C6.16117 2.5 9.10744 2.5 15 2.5C20.8926 2.5 23.8388 2.5 25.6694 4.33058C27.5 6.16117 27.5 9.10744 27.5 15C27.5 20.8926 27.5 23.8388 25.6694 25.6694C23.8388 27.5 20.8926 27.5 15 27.5ZM11.2121 11.2121C11.5782 10.846 12.1718 10.846 12.5379 11.2121L15 13.6742L17.4621 11.2121C17.8282 10.846 18.4218 10.846 18.7879 11.2121C19.154 11.5782 19.154 12.1718 18.7879 12.5379L16.3258 15L18.7879 17.4621C19.154 17.8282 19.154 18.4218 18.7879 18.7879C18.4217 19.154 17.8282 19.154 17.462 18.7879L15 16.3258L12.5379 18.7879C12.1718 19.154 11.5782 19.154 11.2121 18.7879C10.846 18.4218 10.846 17.8282 11.2121 17.4621L13.6742 15L11.2121 12.5379C10.8459 12.1718 10.8459 11.5782 11.2121 11.2121Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Expired;
